import { CanGraphMessages, TranslationCanGraphMessages } from "../interfaces/canGraphMessages";

const canGraphMessages: TranslationCanGraphMessages = {
  [CanGraphMessages.title]: "Gráfico CAN",
  [CanGraphMessages.vehicle]: "Vehículo",
  [CanGraphMessages.day]: "Día",
  [CanGraphMessages.apply]: "Aplicar",
  [CanGraphMessages.loading]: "Cargando datos de la red CAN…",
  [CanGraphMessages.noDataTitle]: "Seleccione un vehículo y un día para visualizar la red CAN",
  [CanGraphMessages.noDataDescription]: "Solo se consultan los comandos ST300STT (única fuente de datos CAN). Se prefiere caché; el historial es respaldo.",
  [CanGraphMessages.fields]: "Campos",
  [CanGraphMessages.fieldsCanGroup]: "Red CAN",
  [CanGraphMessages.fieldsTrackerGroup]: "Comparativos del rastreador",
  [CanGraphMessages.selectAll]: "Seleccionar todos",
  [CanGraphMessages.clearAll]: "Limpiar",
  [CanGraphMessages.zoomIn]: "Acercar",
  [CanGraphMessages.zoomOut]: "Alejar",
  [CanGraphMessages.resetZoom]: "Restablecer zoom",
  [CanGraphMessages.sourceLabel]: "Origen de los datos",
  [CanGraphMessages.sourceCache]: "Caché (reg_trackers_data_cache)",
  [CanGraphMessages.sourceData]: "Histórico (reg_trackers_data)",
  [CanGraphMessages.sourceTooltipCache]: "Datos no procesados (todos los mensajes de los últimos 10 días)",
  [CanGraphMessages.sourceTooltipData]: "Datos procesados (solo mensajes \"importantes\", sin límite de retención)",
  [CanGraphMessages.pointsCount]: "Puntos",
  [CanGraphMessages.devId]: "IMEI",
  [CanGraphMessages.invalidDateRange]: "Intervalo inválido. Seleccione un único día.",
  [CanGraphMessages.vehicleWithoutHardware]: "Vehículo sin rastreador vinculado.",
  [CanGraphMessages.success]: "Datos de la red CAN cargados.",
  [CanGraphMessages.error]: "Error al cargar los datos de la red CAN.",
  [CanGraphMessages.fieldCanSpd]: "Velocidad CAN (km/h)",
  [CanGraphMessages.fieldCanEngineRpm]: "RPM del motor",
  [CanGraphMessages.fieldCanEngineCoolantTemperature]: "Temp. refrigerante (°C)",
  [CanGraphMessages.fieldCanFuelLevelSmoothed]: "Nivel de combustible",
  [CanGraphMessages.fieldCanFuelConsumption]: "Consumo de combustible",
  [CanGraphMessages.fieldCanTotalFuelUsed]: "Combustible total usado (L)",
  [CanGraphMessages.fieldCanTotalFuelUsedCounted]: "Combustible total (contado) (L)",
  [CanGraphMessages.fieldCanTotalIdleFuelUsed]: "Combustible en ralentí (L)",
  [CanGraphMessages.fieldCanTotalEngineHours]: "Horas de motor (h)",
  [CanGraphMessages.fieldCanTotalEngineHoursCounted]: "Horas de motor (contado) (h)",
  [CanGraphMessages.fieldCanTotalDrivingTime]: "Tiempo total de conducción (h)",
  [CanGraphMessages.fieldCanOdometer]: "Odómetro CAN (m)",
  [CanGraphMessages.fieldCanIgn]: "Ignición CAN (0/1)",
  [CanGraphMessages.fieldCanGcvw]: "Peso bruto combinado (kg)",
  [CanGraphMessages.fieldSpd]: "Velocidad GPS (km/h)",
  [CanGraphMessages.fieldDist]: "Odómetro rastreador (m)",
  [CanGraphMessages.fieldHMeter]: "Horímetro rastreador (min)",
  [CanGraphMessages.fieldPwrVolt]: "Tensión principal (V)"
};

export const messages = canGraphMessages;
